export const KompasDblCode = "kompas-dbl";
export const KompasSglCode = "kompas-sgl";
export const RomanoCode = "romano";
export const TreviCode = "trevi";

export const CGF300Code = "cgf300";
export const CGF350Code = "cgf350";
export const CGF400Code = "cgf400";
export const CGS200Code = "cgs200";

export const CGFSystemCodes = [CGF300Code, CGF350Code, CGF400Code];
export const NonSteelSystemCodes = [
    CGS200Code,
    CGF300Code,
    CGF350Code,
    CGF400Code,
    KompasDblCode,
    KompasSglCode,
];
export const CGSAndCGFSystemCodes = [
    CGS200Code,
    CGF300Code,
    CGF350Code,
    CGF400Code,
];
export const SteelSystemCodes = [TreviCode, RomanoCode];
export const KompasSystemCodes = [KompasSglCode, KompasDblCode];

export const OutOfSquareCode = "outsq-01";
export const CostDealType = "cost";
export const B2BDealType = "b2b";
export const B2CDealType = "b2c";

export const DividerPartitionCode = "div";
export const GlassPartitionCode = "fxp";
export const DoorPartitionCode = "dr";
export const MultiFoldingPartitionCode = "foldp";
export const MultiSlidingPartitionCode = "foldp";

export const GlassSortCode = "clear";
export const GlassSortClearCode = "clear";
export const GlassThicknessCode = "1-4";
export const GlassThicknessCode1_4 = "1-4";
export const GlassThicknessCode1_2 = "1-2";
export const GlassThicknessCode3_8 = "3-8";
export const GlassThicknessCode3_16 = "3-16";

export const PartitionGlassCode = "fxp";
export const DividerCode = "div";

export const DoorNoneCode = "dr-none";
export const DoorCode = "door";
export const SteelFoldingDoorsCode = "st-fl";
export const SteelMultiSlidingDoorsCode = 'st-ml-sl';

export const SteelSingleSwingDoorCode = 'st-s-sw';
export const SteelSingleSlidingDoorCode = 'st-s-sl';
export const SteelArchSingleSwingDoorCode = 'st-s-ar';
export const CGSSingleSlidingDoorCode = 'cgs-s-sl';
export const CGSSingleSwingDoorCode = 'cgs-s-sw';
export const CGFSingleSlidingDoorCode = 'cgf-s-sl';
export const CGFSingleSwingDoorCode = 'cgf-s-sw';
export const KompasSingleFramedDoorCode = 'kmp-s';

export const SteelDoubleSwingDoorsCode = 'st-d-sw';
export const SteelDoubleSlidingDoorsCode = 'st-d-sl';
export const SteelArchDoubleSwingDoorsCode = 'st-d-ar';
export const CGSDoubleSlidingDoorsCode = 'cgs-d-sl';
export const CGSDoubleSwingDoorsCode = 'cgs-d-sw';
export const CGFDoubleSlidingDoorsCode = 'cgf-d-sl';
export const CGFDoubleSwingDoorsCode = 'cgf-d-sw';
export const KompasDoubleFramedDoorCode = 'kmp-d';


export const SwingDoors = [
    SteelSingleSwingDoorCode, SteelArchSingleSwingDoorCode, CGSSingleSwingDoorCode, CGFSingleSwingDoorCode, SteelDoubleSwingDoorsCode, SteelArchDoubleSwingDoorsCode, CGSDoubleSwingDoorsCode, CGFDoubleSwingDoorsCode, KompasSingleFramedDoorCode, KompasDoubleFramedDoorCode
];

export const SlidingDoors = [
    SteelSingleSlidingDoorCode, CGSSingleSlidingDoorCode, CGFSingleSlidingDoorCode, SteelDoubleSlidingDoorsCode, CGSDoubleSlidingDoorsCode, CGFDoubleSlidingDoorsCode,
];

export const SingleDoors = [
    SteelSingleSwingDoorCode,
    SteelSingleSlidingDoorCode,
    SteelArchSingleSwingDoorCode,
    CGSSingleSlidingDoorCode,
    CGSSingleSwingDoorCode,
    CGFSingleSlidingDoorCode,
    CGFSingleSwingDoorCode,
    KompasSingleFramedDoorCode,
];

export const DoubleDoors = [
    SteelDoubleSwingDoorsCode,
    SteelDoubleSlidingDoorsCode,
    SteelArchDoubleSwingDoorsCode,
    CGSDoubleSlidingDoorsCode,
    CGSDoubleSwingDoorsCode,
    CGFDoubleSlidingDoorsCode,
    CGFDoubleSwingDoorsCode,
    KompasDoubleFramedDoorCode,
];

export const SingleSwingDoors = [
    CGSSingleSwingDoorCode,
    CGFSingleSwingDoorCode,
    SteelSingleSwingDoorCode,
    SteelArchSingleSwingDoorCode,
];

export const SingleSlidingDoors = [
    CGSSingleSlidingDoorCode,
    CGFSingleSlidingDoorCode,
    SteelSingleSlidingDoorCode,
];

export const DoubleSwingDoors = [
    CGSDoubleSwingDoorsCode,
    CGFDoubleSwingDoorsCode,
    SteelDoubleSwingDoorsCode,
    SteelArchDoubleSwingDoorsCode,
];

export const DoubleSlidingDoors = [
    CGSDoubleSlidingDoorsCode,
    CGFDoubleSlidingDoorsCode,
    SteelDoubleSlidingDoorsCode,
];

export const KompasDoors = [
    KompasSingleFramedDoorCode,
    KompasDoubleFramedDoorCode,
];

export const CGFDoors = [
    CGFDoubleSwingDoorsCode,
    CGFSingleSwingDoorCode,
    CGFDoubleSlidingDoorsCode,
    CGFSingleSlidingDoorCode,
];

export const SteelDoors = [SteelFoldingDoorsCode, SteelMultiSlidingDoorsCode,
    SteelDoubleSwingDoorsCode, SteelDoubleSlidingDoorsCode, SteelArchDoubleSwingDoorsCode, SteelSingleSwingDoorCode, SteelSingleSlidingDoorCode, SteelArchSingleSwingDoorCode
];

export const AllDoorsCodes = [
    ...SlidingDoors,
    ...SingleDoors,
    ...DoubleDoors,
    ...SingleSwingDoors,
    ...SingleSlidingDoors,
    ...DoubleSwingDoors,
    ...DoubleSlidingDoors,
    ...KompasDoors,
];

export const NoDoors = [DoorNoneCode, DividerCode];

// Fillers

export const OverdoorNoneCode = "none";
export const OverdoorCode = "overdoor";
export const OverdoorFillerCode = "filler";
export const OverdoorTransomCode = "transom";

export const GlassMaterialCode = "glass";
export const SheetMaterialCode = "aluminum";

export const OverdoorAssetsCode = "assets-01";

export const MountPerimeterCode = "mnt-perimeter";
export const MountTopBottomCode = "mnt-topbottom";
export const KompasFrameCode = "mnt-kompas-frame";
export const KompasFramelessCode = "mnt-kompas-frameless";
export const NoMountCode = "mnt-none";

export const OverheadDrawingCode = "oh-dr-01";
export const OverheadDrawingTypeCode = "oh-dr";

export const OverheadCuttingMaterialCode = "oh-cut-01";
export const OverheadCuttingMaterialTypeCode = "oh-cut";

export const OverheadPackingCode = "oh-pack-01";
export const OverheadPackingTypeCode = "oh-pack";

export const OverheadGasParkingTollCode = "oh-gas-01";
export const OverheadGasParkingTollTypeCode = "oh-gas";

export const OverheadMeasurementsCode = "oh-msr-01";
export const OverheadMeasurementsTypeCode = "oh-msr";

export const OverheadUploadingCode = "oh-up-01";
export const OverheadUploadingTypeCode = "oh-up";

export const DeliveryCombinedType = "combined";
export const DeliveryDirectType = "direct";
export const DeliveryNonSelectedType = "no-delivery";
export const minWeightForDirectDelivery = 2500;
export const maxWeightPerTrack = 3500;

export const DeliveryTypes = [
    DeliveryCombinedType,
    DeliveryDirectType,
    DeliveryNonSelectedType,
];

export const DeliveryCombinedTypeCode = "dlvr-combine";
export const DeliveryDirectTypeCode = "dlvr-direct";
export const DeliveryInstallationTypeCode = "dlvr-install";

export const DeliveryCombinedCode = "dlvr-combine-01";
export const DeliveryDirectCode = "dlvr-direct-01";
export const DeliveryInstallationCode = "dlvr-install-01";
